import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Upload, Button, Table} from 'antd'
import {UploadOutlined, ExclamationCircleFilled, DeleteOutlined} from '@ant-design/icons'
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
const storage = window.localStorage

@inject('emailListStore', 'marketingSmsManagementStore', 'accountStore')
@observer
class FormImport extends Component {
  formRef = React.createRef()
  beforeUpload = (file, FileList) => {
    return true
  }

  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)
    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`
    }
  }

  onChange = (info) => {
    const {emailListStore, marketingSmsManagementStore, accountStore, handleCancel} = this.props
    const {searchItem} = emailListStore
    const {generateID} = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn)
      } else {
        emailListStore.onAddressAction({
          'sourceType': '2',
          'email': '',
          'taskGroupId': generateID,
          'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
          'page': 1,
          'size': PAGE_SIZE_DEFAULT
        })
        emailListStore.onStatisticsAction({
          "taskGroupId": generateID,
        })
        handleCancel()
        alertMessage.success('导入成功!')
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('导入失败！')
    }
  }

  handleExport = () => {
    // 创建隐藏的链接元素
    const link = document.createElement('a');
    link.href = '/地址.xlsx'; // 文件需要放在 public 目录下
    link.download = '地址.xlsx'; // 设置下载文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const {emailListStore, marketingSmsManagementStore, importModalVisible, handleCancel, marketGroupId, t} = this.props
    const {searchItem} = emailListStore
    const {generateID} = marketingSmsManagementStore
    const {Dragger} = Upload
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/market/management/email/fileImport`
    // 待发送列表的 searchItem.marketGroupId 是 null，优先用调用方传入的当前弹窗项目组
    const currentMarketGroupId = marketGroupId || searchItem?.marketGroupId
    return (
      <>
        <Modal
          title={t(`emailSend.addAddressTit`)}
          // closable={false}
          visible={importModalVisible}
          onCancel={() => { handleCancel('importModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
          width={600}
        >
          <Dragger
            accept=".xlsx"
            action={UPLOAD_TEMPLATE_URL}
            headers={this.getHeader()}
            style={{width: '100%', margin: '0 auto'}}
            onChange={this.onChange}
            data={{
              marketGroupId: currentMarketGroupId,
              taskGroupId: generateID,
            }}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{color: '#031a34'}}/>
            </p>
            <p className="ant-upload-text">{t(`dataTarget.dragFile`)}</p>
            <p className="ant-upload-hint" style={{ marginBottom: '10px' }}>
              支持文件格式(*.xlsx;)，文件最大允许20M。
            </p>
          </Dragger>
          <div style={{marginTop: 20, position: 'relative'}}>
            请先下载模板按说明填写信息后上传
            <Button type="primary" onClick={this.handleExport} style={{ position: 'absolute', right: 0,}}>下载模板</Button>
          </div>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormImport)
